<template>
  <!-- 取消极速约单，弹窗 -->
  <el-dialog
    append-to-body
    :visible.sync="show"
    :width="isMobile ? '90vw' : '500px'"
    custom-class="dialog-cancel"
    :close-on-click-modal="isMobile"
    :before-close="handleClose"
    @close="$emit('close')"
  >
    <div slot="title" class="title">{{$t('upgrade_page_views_quick_order_quick_order_cancel_1331')}}</div>
    <div :class="['cancel-wrap', showTextarea ? 'choice-other' : '']">
      <div class="cancel-content">
        <div class="form">
          <div class="title">
            <h3>{{$t('upgrade_page_views_quick_order_quick_order_cancel_1332')}}</h3>
            <p>{{$t('upgrade_page_views_quick_order_quick_order_cancel_1333')}}</p>
          </div>
          <ul class="list">
            <li v-for="(item, index) in reasons" :key="item" @click="choice = index + 1">
              <span><template v-if="isMobile">{{ index + 1 }}.</template>{{ item }}</span>
              <div :class="['radio', choice == index + 1 ? 'active' : '']"></div>
            </li>
          </ul>
          <div
            v-show="showTextarea"
            class="textarea-wrap"
          >
            <textarea
              v-show="showTextarea"
              class="textarea"
              v-model="textareaText"
              @click="stopPro($event)"
              :placeholder="isMobile ? $t('upgrade_page_views_quick_order_quick_order_cancel_1334') : $t('upgrade_page_views_quick_order_quick_order_cancel_1335')"
            >
            </textarea>
            <div 
              v-show="showTextarea"
              class="letter-num"
            >
              <span :class="textareaText.length > textareaTextMaxLength ? 'light' : ''">{{ textareaText.length }}</span>/{{ textareaTextMaxLength }}
            </div>
          </div>
        </div>
      </div>
      <div class="cancel-bottom">
        <button v-if="!isMobile" class="cancel" @click="show = false">{{$t('upgrade_page_layout_header_42')}}</button>
        <button class="submit" :class="{ 'disabled': !hasReason }" @click="submit">
          <i v-if="isLoading" class="el-icon-loading" />
          <span v-else>{{$t('components_order_order_card_525')}}</span>
        </button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import i18n from '@/locales/index'
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    uuid: {
      type: String,
      default: ''
    }
  },
  data() {
    const REASONS = [i18n.t('upgrade_page_views_quick_order_quick_order_cancel_1336'), i18n.t('upgrade_page_views_quick_order_quick_order_cancel_1337'), i18n.t('upgrade_page_views_quick_order_quick_order_cancel_1338'), i18n.t('upgrade_page_views_quick_order_quick_order_cancel_1339'), i18n.t('upgrade_page_views_quick_order_quick_order_cancel_1340')]
    return {
      isMobile: false,
      show: false,
      isLoading: false,
      reasons: REASONS,
      choice: 0,
      textareaText: '',
      textareaTextMaxLength: 100
    }
  },
  computed: {
    showTextarea() {
      return this.choice === this.reasons.length
    },
    hasReason() {
      return this.choice && !this.showTextarea || this.showTextarea && this.textareaText.replace(/\s/g, '')
    }
  },
  watch: {
    open(value) {
      this.show = value
      this.isMobile = document.body.clientWidth < 600
    }
  },
  created() {
    // this.isMobile = document.body.clientWidth < 600
  },
  methods: {
    submit() {
      if (!this.hasReason) {
        this.$message.error(i18n.t('upgrade_page_views_quick_order_quick_order_cancel_1341'))
        return
      }
      if (this.showTextarea && (this.textareaText.length > this.textareaTextMaxLength)) {
        this.$message.error(i18n.t('upgrade_page_views_quick_order_quick_order_cancel_1342', [ this.textareaTextMaxLength ]))
        return
      }
      this.isLoading = true
      // this.$confirm({
      //   content: '當日取消超過三次，會影響您之後的約單喔，真的要丟下陪玩師嗎？',
      //   title: '確認取消本次下單嗎？',
      //   confirmButtonText: '再想想',
      //   cancelButtonText: '忍痛離開',
      // }).catch(() => {
      // })
      const cancelReason = this.showTextarea ? this.textareaText : this.reasons[this.choice - 1]
      this.$http.post('/match/quick/cancel', {
        uuid: this.uuid,
        cancelReason,
      }).then(() => {
        this.isLoading = false
        this.$emit('submit')
      }).catch((err) => {
        this.isLoading = false
        // this.$emit('error', err)
        this.$message.error(err.msg)
        this.$emit('close')
        this.$router.go(0)
      })
    },

    handleClose(done) {
      if (this.isLoading) return
      done()
    },

    stopPro(e) {
      e = e || window.event
      e.stopPropagation ? e.stopPropagation() : (e.cancelBubble = true)
    }
  },
}
</script>

<style lang="scss" scoped>
  /deep/ .dialog-cancel {
    border-radius: 8px;
    .el-dialog__header {
      padding: 14px 20px;
      line-height: 22px;
      font-size: 16px;
      font-weight: 500;
      color: #000;
      border-bottom: 1px solid #ECECEC;
      .title {
        text-align: center;
      }
      .el-dialog__headerbtn {
        right: 20px;
        top: 16px;
      }
    }
    .el-dialog__body {
      padding: 21px 27px 25px;
    }
  }
  .cancel {
    &-wrap {
      display: flex;
      flex-direction: column;
      &.choice-other {
        .cancel-bottom {
          padding: 15px 0 0;
        }
      }
    }
    &-content {
      flex-grow: 1;
    }
    &-bottom {
      flex-shrink: 0;
      padding: 30px 0 0;
      display: flex;
      justify-content: flex-end;
      button {
        width: 100px;
        height: 46px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 500;
        &.cancel {
          color: #666;
          background-color: #eee;
          margin-right: 10px;
        }
        &.submit {
          color: #fff;
          background-color: #FA006E;
          &:active, &:hover {
            background-color: #E10063
          }
        }
        // &.disabled {
        //   background-color: #eee!important;
        // }
      }
    }
  }
  .form {
    .title {
      h3 {
        color: #333;
        font-weight: 500;
        font-size: 18px;
        line-height: 20px;
      }
      p {
        color: #666;
        font-size: 14px;
        line-height: 20px;
        margin-top: 7px;
      }
    }
    .list {
      padding-top: 29px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      list-style: none;
      li {
        display: flex;
        flex-direction: row-reverse;
        justify-content: flex-start;
        line-height: 20px;
        margin-top: 20px;
        cursor: pointer;
        &:first-child {
          margin-top: 0;
        }
        .radio {
          position: relative;
          flex-shrink: 0;
          padding: 0;
          margin-right: 8px;
          &::after {
            content: '';
            display: block;
            width: 20px;
            height: 20px;
            border: 1px solid #999;
            border-radius: 100%;
          }
          &.active {
            &::before {
              content: '';
              position: absolute;
              z-index: 1;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              width: 10px;
              height: 10px;
              border-radius: 100%;
              background: linear-gradient(126deg, #FF4417 2.04%, #FB006E 60.91%);
            }
          }
        }
      }
    }
  }
  .textarea-wrap {
    position: relative;
    margin-top: 10px;
    height: 134px;
    padding-left: 28px;
    &.hidden {
      display: none;
    }
    .textarea {
      width: 100%;
      height: 100%;
      resize: none;
      box-sizing: border-box;
      padding: 12px 15px;
      font-size: 14px;
      line-height: 20px;
      color: #333;
      border: 1px solid #E5E5E5;
      background-color: #FBFBFB;
      border-radius: 5px;
    }
    .letter-num {
      font-size: 12px;
      line-height: 16px;
      color: #9D9D9D;
      position: absolute;
      bottom: 8px;
      right: 10px;
      .light {
        color: #FA006E;
      }
    }
  }
  @media screen and(max-width: 599px) {
    /deep/ .dialog-cancel {
      height: 465px;
      overflow: hidden;
      .el-dialog__header {
        padding: 19px 18px;
        line-height: 24px;
        font-size: 18px;
        .title {
          text-align: left;
        }
        .el-dialog__headerbtn {
          right: 18px;
          top: 22px;
        }
      }
      .el-dialog__body {
        height: 402px;
        padding: 0;
      }
    }
    .cancel {
      &-wrap {
        height: 100%;
      }
      &-content {
        overflow-y: scroll;
        padding: 20px 18px 15px;
      }
      &-bottom {
        height: 70px;
        padding: 10px 24px 0!important;
        button {
          height: 40px;
        }
      }
    }
    .form {
      .title {
        padding-bottom: 25px;
        border-bottom: 1px solid #E6E6E6;
      }
      .list {
        padding-top: 26px;
        list-style: decimal inside;
        li {
          flex-direction: row;
          justify-content: space-between;
          width: 100%;
          margin-top: 10px;
          line-height: 42px;
          .radio {
            padding: 12px;
            &::after {
              width: 18px;
              height: 18px;
            }
          }
        }
      }
    }
    .textarea-wrap {
      padding-left: 0;
      height: 150px;
      .textarea {
        border: none;
        padding: 12px 12px 38px;
      }
    }
  }
</style>